import { CSSTransition } from 'react-transition-group';
import { Table } from 'semantic-ui-react';
import cn from 'classnames';
import './LayoutManagerPanel.scss';
import { useAppSelector } from 'store/hooks';
import { layoutsSelectors } from 'store/feature/layoutsSlice';
import LayoutManagerItem from './LayoutManagerItem';
import { createPortal } from 'react-dom';

export interface LayoutManagerPanelProps {
    show: boolean;
    onClose: () => void;
}

const LayoutManagerPanel: React.FC<LayoutManagerPanelProps> = ({
    show,
    onClose,
}) => {
    const layouts = useAppSelector(layoutsSelectors.selectedDatasetLayouts);

    return (
        <>
            {createPortal(
                <CSSTransition
                    classNames="activity"
                    in={show}
                    timeout={300}
                    unmountOnExit
                >
                    <div
                        id="layoutManager"
                        className={cn('layoutManager', 'layoutManager-compact')}
                    >
                        <div
                            className={'layoutManager-topbar'}
                            id="layoutManager-menu"
                            onClick={onClose}
                        >
                            <div className="layoutManager-topbar-chevron" />
                            <div className="layoutManager-topbar-title">
                                Layout Manager
                            </div>
                        </div>
                        <div className="layoutManager-info">
                            <span className="layoutManager-info-item">
                                ★ <strong>Star</strong> — Default layout at
                                startup.
                            </span>
                            <span className="layoutManager-info-separator">
                                ·
                            </span>
                            <span className="layoutManager-info-item">
                                📌 <strong>Pin</strong> — Auto-loads for
                                selected groups. Click to choose groups.
                            </span>
                        </div>
                        <div className="layoutManager-content">
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th style={{ minWidth: 205 }}>Name</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {layouts.map((model) => (
                                        <LayoutManagerItem model={model} />
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </CSSTransition>,
                document.body
            )}
        </>
    );
};

export default LayoutManagerPanel;
